import * as def from "./default.js";
import * as registration from "./registration.js";
import * as bonus_cards from "./bonus_cards.js";

export default Object.assign(
  def,
  registration,
  bonus_cards,
);
